import React, { useState } from 'react';
import { Input, InputGroup, InputGroupText } from 'reactstrap';

const PasswordInput = ({ ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <InputGroup>
      <Input
        {...props}
        type={showPassword ? 'text' : 'password'}
      />
      <InputGroupText
        onClick={togglePassword}
        style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
      >
        <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
      </InputGroupText>
    </InputGroup>
  );
};

export default PasswordInput;